import React from 'react';
import {  Row, Col  } from 'antd';
/*
import { connect } from 'react-redux';

import Container from '../../components/container/Container'
*/

import SlcpContainer from '../container/SlcpContainer'
import OverviewBody from './overviewBody'

import DougContainer from '../container/DougContainer'
import ODougBody from './odougBody'

import PieContainer from '../container/PieContainer'
import OPieBody from './opieBody'
/*
import Loader from '../../components/Loader';
import ErrorWidget from '../../components/ErrorWidget';
import {getExperiment} from './actions/graphAction'
*/
import _ from 'lodash'

import './nms.css'

class OverviewContainer extends React.Component{

    constructor(props){
        super(props)
    }

    makerArray =(data)=>{
        _.sortBy(data, function(o, ix){
            return  

        })

    }
    addArForRow=(rowNum, data, outer)=>{
        let cor = 0.3
        for(let j=0; j<3; j++){
            cor =0.3
            let cell =_.find(data,{rowNum:rowNum+1, colNum:j+1})
            console.log('sv cell+++++++++')
            console.log(cell)
            if(cell){
                cor = parseFloat(cell.cor)
                let cor3Decimals = cor.toFixed(3)
                cor = parseFloat(cor3Decimals)
            }
            outer.push([rowNum,j, cor])
        }
    }
    makeGraphData=(data)=>{
        //rows max , col max
        let outer = []
        let xLabels = []
        let x_name = 'x_no'
        let y_name = 'y_no'
        let yLabels = []
        let ar = [0,0,1]

        let total_rows = 3
        let total_cols = 3
        for(let i=0; i < 3; i++){
            this.addArForRow(i, data, outer)
            let cell =_.find(data,{rowNum:i+1, colNum:1})
            if(cell){
                x_name = cell.rowLabel
            }
            xLabels.push(x_name)
            yLabels.push(x_name)

        }
        let myOb = {
            orgData: data,
            data: outer,
            xLabels:xLabels,
            yLabels:yLabels
        }
        return myOb
        

       
    }
    getGraphBody(expData, cmsData, legend){
        return(<OverviewBody data={expData} cmsData={cmsData} legend={legend}/>)
    }
    getODougBody(expData, cmsData, legend){
        return(<ODougBody data={expData} cmsData={cmsData} legend={legend}/>)
    }
    getOPieBody(expData, cmsData, legend){
        return(<OPieBody data={expData} cmsData={cmsData} legend={legend}/>)
    }
    render(){
        let me = this
        const legend = [
            {
               
                color: 'pnp-match-available',
                name: 'Compliant'
            },
            {
                color: 'pnp-unmatch-available',
                name: 'Phase Out'
            },
            {
                color: 'os-not-available',
                name: 'Non Compliant'
            }
        ]

        let data = [
            
            {
                "id": 6,
                "experimentName": "Replicate5",
                "rowNum": "1",
                "colNum": "1",
                "rowLabel": "R0",
                "colLabel": "R0",
                "cor": "1"
            },
            {
                "id": 7,
                "experimentName": "Replicate5",
                "rowNum": "1",
                "colNum": "2",
                "rowLabel": "R0",
                "colLabel": "R0",
                "cor": "1"
            },
            {
                "id": 9,
                "experimentName": "replicateSV21",
                "rowNum": "1",
                "colNum": "2",
                "rowLabel": "ENCFF415GFH",
                "colLabel": "ENCFF231NTN",
                "cor": "0.9086108466453972"
            },
            {
                "id": 10,
                "experimentName": "replicateSV21",
                "rowNum": "1",
                "colNum": "3",
                "rowLabel": "ENCFF415GFH",
                "colLabel": "ENCFF075MCN",
                "cor": "0.9440514340970708"
            },
            {
                "id": 11,
                "experimentName": "replicateSV21",
                "rowNum": "2",
                "colNum": "1",
                "rowLabel": "ENCFF231NTN",
                "colLabel": "ENCFF415GFH",
                "cor": "0.9086108466453972"
            },
            {
                "id": 12,
                "experimentName": "replicateSV21",
                "rowNum": "2",
                "colNum": "2",
                "rowLabel": "ENCFF231NTN",
                "colLabel": "ENCFF231NTN",
                "cor": "0.9999999999999999"
            },
            {
                "id": 13,
                "experimentName": "replicateSV21",
                "rowNum": "2",
                "colNum": "3",
                "rowLabel": "ENCFF231NTN",
                "colLabel": "ENCFF075MCN",
                "cor": "0.9082739152938084"
            },
            {
                "id": 15,
                "experimentName": "replicateSV21",
                "rowNum": "3",
                "colNum": "2",
                "rowLabel": "ENCFF075MCN",
                "colLabel": "ENCFF231NTN",
                "cor": "0.9082739152938084"
            },
            {
                "id": 14,
                "experimentName": "replicateSV21",
                "rowNum": "3",
                "colNum": "1",
                "rowLabel": "ENCFF075MCN",
                "colLabel": "ENCFF415GFH",
                "cor": "0.9440514340970708"
            },
            {
                "id": 16,
                "experimentName": "replicateSV21",
                "rowNum": "3",
                "colNum": "3",
                "rowLabel": "ENCFF075MCN",
                "colLabel": "ENCFF075MCN",
                "cor": "1.0"
            },
            {
                "id": 8,
                "experimentName": "replicateSV21",
                "rowNum": "1",
                "colNum": "1",
                "rowLabel": "ENCFF415GFH",
                "colLabel": "ENCFF415GFH",
                "cor": "1.0"
            },
            {
                "id": 1,
                "experimentName": "sv1",
                "rowNum": "1",
                "colNum": "1",
                "rowLabel": "R-1",
                "colLabel": "R-1",
                "cor": "0.3333"
            },
            {
                "id": 4,
                "experimentName": "sv2",
                "rowNum": "1",
                "colNum": "1",
                "rowLabel": "R-1",
                "colLabel": "R-1",
                "cor": "0.3333"
            },
            {
                "id": 17,
                "experimentName": "sv2",
                "rowNum": "1",
                "colNum": "1",
                "rowLabel": "R-1",
                "colLabel": "R-1",
                "cor": "0.3333"
            }
        ]
        let cmsData=[]
        let expName = "replicateSV21"
        if(this.props.hm_data && (this.props.hm_data.length > 0 )){
            data  = this.props.hm_data

        }else{
            console.log('error  data from focntianrx*****************')
        }
        // make data int for rowNum, colNum
        data.map((o,idx)=>{
             o['rowNum'] = parseInt(o['rowNum']);
             o['colNum'] = parseInt(o['colNum']);
           
        })
        console.log('int----%%%Daa')
        console.log(data)

    /*
        let expData = data.filter((o , id)=>{
            return o.experimentName == expName

        } )
*/
       let expData = data;
       let expDataSorted =  _.sortBy(expData, 'rowNum')
        expData = this.makeGraphData(expDataSorted)

       
        
        console.log('sv ---expData')
        console.log(expData)
        console.log('sv data --- expdata...')
        

        return (
            <div>
                 <SlcpContainer className="card-heatmap" title="Historic and Estimated Assesment Growth by Section/IssueCategory" subtitle="" body={me.getGraphBody(expData, cmsData, legend)}>
            </SlcpContainer>
                <Row>
                    <Col span={12}>
                    <PieContainer className="card-heatmap" title="Airlines Service In US Cities Share(%) Sept 2024 - Aug 2025" subtitle="" body={me.getOPieBody(expData, cmsData, legend)}>
            </PieContainer>
                    </Col>
                    <Col span={12}>
                    <DougContainer className="card-heatmap" title="Airlines from Airports in US (Number of  Airports)" subtitle="" body={me.getODougBody(expData, cmsData, legend)}>
            </DougContainer>
                    </Col>
                </Row>
                 
            
           
            </div>
        )
        
    }

   
}

export default OverviewContainer
